<template>
   <el-dialog
        title="如何发抖音？"
        :visible.sync="value"
        width="50%"
        v-if="value"
        @close="handleClose"
      >
        <video
          src="https://doubaosrc.doutuimao.net/teacherpc/dycourse.mp4"
          controls
          autoplay
          style="max-height: 70vh;width: 100%; margin: 0 auto; display: block"
        ></video>
      </el-dialog>
</template>
<script>
export default {
    name: 'Tiktok',
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleClose() {
            this.$emit('input', false)
        }
    }
}
</script>